import { Button, Flex, Row } from "antd";
import React, { memo } from "react";

const TmsCancelSubmitButtons = ({
  cancelOnlick,
  submitOnclick,
  icon,
  loading,
}) => {
  return (
    <Row style={{ margin: "20px 0px" }} justify="center">
      <Button type="default" onClick={cancelOnlick} loading={loading}>
        Cancel
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: "20px", background: "#e11513", color: "white" }}
        onClick={submitOnclick}
        loading={loading}
      >
        <Flex>
          {" "}
          Submit{" "}
          <img
            src={icon}
            alt=""
            style={{
              paddingLeft: "3px",
              filter: "invert(1)",
            }}
          />
        </Flex>
      </Button>
    </Row>
  );
};

export default memo(TmsCancelSubmitButtons);
